import gStyles from "../../../styles/pages/botStore.module.scss";
import styles from "../../../styles/pages/addproduct.module.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import endpoints from "../../../utility/endpoints";
import Multiselect from 'multiselect-react-dropdown';
import { imageBaseURL } from "../../../data/createBotForm";
import Creatable, { useCreatable } from 'react-select/creatable';
import Select, { components } from "react-select";
import { remove } from "lodash";

function index({isAdd, setAddProduct, data, onSuccess}) {

    const [inputData, setInputData] = useState({})
    const [benefits, setBenifits] = useState([])
    const [process, setProcess] = useState([])
    const [isFormValid, setIsFormValid] = useState(false)
    const onChange = (key, value) => {
        checkValid();
        setInputData(old => ({...old, [key]:value}));
    }
    const onChangeBenefit = (key, value) => {
        checkValid()
        setInputData(old => ({...old, [key]:value.map(item=> {
            if(item?.__isNew__){
                let obj = { benefit: item.value, benefit_icon: "benefits1.svg"}
                let old = [...benefits]
                old.push(obj)
                setBenifits(old)
                return obj;
            }
            return item.value
        })}));
    }

    const onChangeProcess = (key, value) => {
        checkValid()
        setInputData(old => ({...old, [key]:value.map(item=> {
            if(item?.__isNew__){
                let obj = { process_text: item.value, process_head: ""} 
                let old = [...process]
                old.push(obj)
                setProcess(old)
                return obj;
            }
            return item.value
        })}));
    }

    useEffect(()=>{
        if(data){
            let ccData = JSON.parse(JSON.stringify(data))
            let lead = [...ccData.lead]
            let act = { ...ccData, lead: lead.map(item=> {
                item.country = item.country.toString()
                return item;
            })}
            setInputData(act);
            setBenifits(data.benefits)
            setProcess(data.process)
        }
        else {
            setInputData({lead: [{cluster: '', country: ''}]})
        }
    }, [])

    const addUpdateProduct = async () => {

        let auth = JSON.parse(localStorage.getItem("auth")).data;
        let body = {...inputData};
        body.lead = body.lead.map(item => {
            item.country = item?.country?.split(",")
            return item;
        })
        try {
            
          const productResponse = await axios({
            method: "POST",
            url: `${endpoints.baseUrl}${isAdd ? '/task/createProduct' : '/task/updateProduct'}`,
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: body,
          });
          onSuccess();
        } catch (e) {
          console.log("failed to create Product"+e);
        }
      };

    const onLeadChange = (idx, key, value) => {
        let cc = [...inputData.lead]
        cc[idx] = {...cc[idx], [key]: value}
        onChange('lead', cc)
    }

    const addLead = () => {
        let cc = [...inputData.lead]
        cc.push({cluster: '', country: ''})
        onChange('lead', cc)
    }

    const removeLead = (idx) => {
        let cc = [...inputData.lead]
        cc.splice(idx, 1)
        onChange('lead', cc)
    }

    

     const checkValid = () => {
    let isValid =
      inputData?.catalog_products != "" &&
      inputData?.catalog_products != null &&
      inputData?.lead?.length > 0 &&
      inputData?.subarea != "" &&
      inputData?.subarea != null &&
      inputData?.product_title != "" &&
      inputData?.product_title != null &&
      inputData?.product_caption != "" &&
      inputData?.product_caption != null &&
      inputData?.hrs_saved != "" &&
      inputData?.hrs_saved != null &&
      inputData?.hrs_saved_text != "" &&
      inputData?.hrs_saved_text != null &&
      inputData?.product_banner != "" &&
      inputData?.product_banner != null &&
      inputData?.product_video != "" &&
      inputData?.product_video != null &&
      inputData?.product_description != "" &&
      inputData?.product_description != null;
    setIsFormValid(isValid);
  };

    return (
        <div className={gStyles.storeContainer}>
            <form name="product">
            <div className={`${styles.addProductContainer} container`}>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Lead Platform</label>
                            <p className={styles.field}>
                                <input disabled={true} value={inputData.lead_platform} type={"text"} onChange={(e)=>onChange('lead_platform', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Business Function<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input type={"text"} value={inputData.catalog_products} onChange={(e)=>onChange('catalog_products', e?.target?.value)} />
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Product Status</label>
                            <p className={styles.field}>
                                <input disabled={true} value={inputData.product_status} type={"text"} onChange={(e)=>onChange('product_status', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                </div>
                {inputData?.lead?.map((item, idx)=> {
                    return <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Cluster<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input  value={item.cluster} type={"text"} onChange={(e)=>onLeadChange(idx, 'cluster', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Country<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={item.country} type={"text"} onChange={(e)=>onLeadChange(idx, 'country', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className={`${styles.leadRowButtons} col-md-1`}>
                     {(idx == inputData.lead.length-1) && <span onClick={()=> addLead()}>Add</span>}
                     {inputData.lead.length> 1 && <span onClick={()=> removeLead(idx)}>Remove</span>}
                    </div>
                    {/* <div className={`${styles.leadRowButtons} col-md-1`}>
                    </div> */}
                    
                </div>
                })}
                 {inputData?.lead?.length === 0 ? <div className="row">
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4">
                    </div>
                    <div className={`${styles.leadRowButtons} col-md-1`}>
                        <span onClick={()=> addLead()}>Add</span>
                    </div>
                </div> : <></>}
                <div className="row">
                    <div className="col-md-4">
                         <div className={styles.addFormControl}>
                            <label>Area<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.area} type={"text"} onChange={(e)=>onChange('area', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                         <div className={styles.addFormControl}>
                            <label>Subarea<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.subarea} type={"text"} onChange={(e)=>onChange('subarea', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Product Title<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.product_title} type={"text"} onChange={(e)=>onChange('product_title', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                 
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Clusters Live</label>
                            <p className={styles.field}>
                                <input disabled={true} type={"text"} value={inputData.clusters_live} onChange={(e)=>onChange('clusters_live', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                         <div className={styles.addFormControl}>
                            <label>Product Caption<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.product_caption} type={"text"} onChange={(e)=>onChange('product_caption', e?.target?.value)} required="true"/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Hrs Saved<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.hrs_saved} type={"text"} onChange={(e)=>onChange('hrs_saved', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Hrs_saved_text<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.hrs_saved_text} type={"text"} onChange={(e)=>onChange('hrs_saved_text', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Benefits<span style={{color:"red"}}></span></label>
                            <Creatable
                                value={inputData?.benefits?.map(item => ({label: item.benefit, value: item}))}
                                onChange={(e)=>{onChangeBenefit('benefits', e)}}
                                options={benefits?.map(item => ({label: item.benefit, value: item}))}
                                isMulti={true}
                                hideSelectedOptions={false}
                                components={{ ValueContainer }}
                                
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Process<span style={{color:"red"}}></span></label>
                            <Creatable
                                value={inputData?.process?.map(item => ({label: item.process_text, value: item}))}
                                onChange={(e)=>{onChangeProcess('process', e)}}
                                options={process?.map(item => ({label: item.process_text, value: item}))}
                                isMulti={true}
                                hideSelectedOptions={false}
                                components={{ ValueContainer }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Product Icon<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.product_banner} type={"text"} onChange={(e)=>onChange('product_banner', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Product Video<span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.product_video} type={"text"} onChange={(e)=>onChange('product_video', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            <label>Product Description <span style={{color:"red"}}>*</span></label>
                            <p className={styles.field}>
                                <input value={inputData.product_description} type={"text"} onChange={(e)=>onChange('product_description', e?.target?.value)}/>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className={styles.addFormControl}>
                            {/* <label>Document URL </label> */}
                             <span style={{color: "#73706e", fontSize: "14px", paddingRight:"3px"}}>Document URL</span> <input type="checkbox" checked={inputData.isDocument} onChange={(e)=>onChange('isDocument', e?.target?.checked)}/>
                           {inputData.isDocument && <p className={styles.field}>
                                <input value={inputData.document_url} type={"text"} onChange={(e)=>onChange('document_url', e?.target?.value)}/>
                            </p>}
                        </div>
                    </div>
                </div>
                
                <div className="row  mt-5 pt-5">
                    <div className="col-md-6 col-12 align-self-end">
                        {/* <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${(imageBaseURL + inputData?.product_video)} paused/>` }} /> */}
                        <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${inputData?.product_video?.includes("https://www.youtube.com/watch?v=") ? (inputData?.product_video)?.replace('https://www.youtube.com/watch?v=','https://www.youtube.com/embed/') : inputData?.product_video?.includes("https://drive.google.com") ? (inputData?.product_video)?.replace('view','preview') : inputData?.product_video} paused/>` }} />
                    </div>
                </div>

                <div class="row mb-3 mt-3">
                    <div className="col-md-12">
                        <div class={styles.actionButtons}>
                            <div class={styles.buttons}>
                                <span class={styles.cancel} onClick={()=>setAddProduct(false)}>Cancel</span>
                                <span class={ isFormValid ? styles.save : styles.saveBlock} onClick={addUpdateProduct} >Save</span>
                            </div>
                        </div>
                    </div>
                </div>

                {(inputData?.benefits?.length> 0 || inputData?.process?.length> 0) && <div className={styles.benefits_section}>
                <div className="container h-100">
                   {inputData?.benefits?.length>0 && <div className={styles.Frist_section}>
                    <div className="mb-5">
                <h1>Top Benefits</h1>
                    </div>
                        <div className="row ">
                            {inputData?.benefits?.length>0 && inputData?.benefits.map((va)=>{
                           return( <div className="col-md-3 col-6  mb-4 mb-md-0">
                                <div className={styles.cards_benefits} style={{marginBottom:"15px"}}>
                                    <img src={`${imageBaseURL + va.benefit_icon}`} alt="" />
                                    <p>{va.benefit}</p>
                                </div>
                            </div>)
                            })}
                        </div>
                        
                    </div>}
                   {inputData?.process?.length >0 && <div className="row">
                        <div className="col-md-6 ">
                            <div className={`text-center position-relative bot_section ${styles.cards_benefits_card}`}>
                                <img src={`${imageBaseURL}robo.png`} alt="" />
                                <div className="back_image">
                                    <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                    <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                    <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                        <h2 className="" style={{fontWeight:"600"}}>{inputData?.process_caption}</h2>
                        {inputData?.process_tex!=="" && <p className="mb-4">{inputData?.process_text}</p>}
                            {/* <p className="mb-4">1,000s of invoices left to be updated! Don’t worry, we can help your team colate & update invoices on your behalf.</p> */}
                            <ol>
                                {inputData?.process?.length>0 && inputData?.process.map((va)=>{
                               return (<li >
                                     <div>
                                       {va.process_head!=="" &&  <h3 style={{color:'#1F36C7'}} >
                                            Detection Systems
                                        </h3>}
                                         <p>{va.process_text}</p>
                                     </div>
                                 </li>)
                                })}
                            </ol>
                        </div>
                    </div>}
                </div>
            </div>}
            </div>
            </form>
        </div>
    );
}

const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;
  
    if (Array.isArray(values)) {
      const { length } = values;
      values = `${length} item selected` 
    }
    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

export default index;
